/**
 * Dev-only replay switch: `?tourReset=1` on the home shows a button that puts
 * the record back to before the walkthrough, through the onboarding API.
 */

import type { UserOnboarding } from "@cohesive/api-client";
import { useState } from "react";
import { useOnboardingRecord, useOnboardingStatus } from "./status";

export function resetPatch(record: UserOnboarding | undefined): UserOnboarding {
  const clear = (map: Record<string, string> | undefined) =>
    Object.fromEntries(Object.keys(map ?? {}).map((key) => [key, ""]));
  return {
    global: "",
    steps: clear(record?.steps),
    refs: clear(record?.refs),
  };
}

export function TourReset() {
  const status = useOnboardingStatus();
  const { record } = useOnboardingRecord();
  const [state, setState] = useState<"idle" | "busy" | "done" | "failed">(
    "idle",
  );
  if (
    !import.meta.env.DEV ||
    new URLSearchParams(window.location.search).get("tourReset") !== "1"
  )
    return null;

  const reset = async () => {
    setState("busy");
    setState((await status.patch(resetPatch(record))) ? "done" : "failed");
  };

  return (
    <button
      type="button"
      onClick={() => void reset()}
      disabled={state === "busy" || !record}
      style={{
        position: "fixed",
        right: 16,
        bottom: 16,
        zIndex: 60,
        padding: "8px 14px",
        borderRadius: 8,
        border: "1px solid rgba(0, 0, 0, 0.15)",
        background: "#fff",
        color: "#111",
        font: "500 13px ui-sans-serif, system-ui, sans-serif",
        cursor: "pointer",
      }}
    >
      {state === "busy"
        ? "Resetting…"
        : state === "done"
          ? "Walkthrough reset · Restart again"
          : state === "failed"
            ? "Reset failed · Try again"
            : "Restart walkthrough"}
    </button>
  );
}
